import { useTheme } from '@mui/system';

interface ComplaintIconProps {
  height?: number;
  width?: number;
  fill?: string;
}

export const ComplaintIcon = ({
  height = 32,
  width = 32,
  fill,
}: ComplaintIconProps) => {
  const theme = useTheme();
  const fillColor = fill || theme.palette.category.complaint;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
    >
      <title>Complaint Icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 4.53333V30.0333L6.66667 24.3667H26.2C27.4694 24.3667 28.5424 23.9285 29.4187 23.0521C30.2951 22.1757 30.7333 21.1028 30.7333 19.8333V4.53333C30.7333 3.26389 30.2951 2.19098 29.4187 1.3146C28.5424 0.4382 27.4694 0 26.2 0H5.53333C4.26387 0 3.19096 0.4382 2.3146 1.3146C1.4382 2.19098 1 3.26389 1 4.53333ZM12.2998 2.90234H18.6998V13.8738H12.2998V2.90234ZM18.6998 18.9031C18.6998 20.6704 17.2671 22.1031 15.4998 22.1031C13.7325 22.1031 12.2998 20.6704 12.2998 18.9031C12.2998 17.1358 13.7325 15.7031 15.4998 15.7031C17.2671 15.7031 18.6998 17.1358 18.6998 18.9031Z"
        fill={fillColor}
      />
    </svg>
  );
};
